import Vue from 'vue'
import App from './App.vue'

import axios from 'axios'
import VueAxios from 'vue-axios'

import Cryptoicon from 'vue-cryptoicon'
import icons from 'vue-cryptoicon/src/icons'
import VueCookies from 'vue-cookies'

import parallax from './plugins/parallax'

import Selectbox from "./components/FormElements/Selectbox"
import RadioGroup from "./components/FormElements/RadioGroup"
import Input from "./components/FormElements/Input"
import ParallaxBlock from "./components/ParallaxBlock"

import '@/assets/styles/main.css'
import '@/assets/styles/animate.css'

Vue.component('Selectbox', Selectbox)
Vue.component('RadioGroup', RadioGroup)
Vue.component('v-input', Input)
Vue.component('ParallaxBlock', ParallaxBlock)

Object.defineProperty(Vue.prototype, '$axios', { value: axios })
Object.defineProperty(Vue.prototype, '$parallax', { value: parallax })

Vue.use(VueAxios, axios)
Vue.use(VueCookies)

Cryptoicon.add(icons)
Vue.use(Cryptoicon)

Vue.config.productionTip = false

const app = new Vue({
  render: h => h(App),
})

app.$mount('#app')
